import { types as sdkTypes } from './sdkLoader';
const { Money } = sdkTypes;

// Exchange rates to USD — updated 2026-05-04
const USD_EXCHANGE_RATES = {
  USD: 1.00,
  AUD: 0.72,
  EUR: 1.17,
  GBP: 1.36,
  CAD: 0.74,
  CHF: 1.28,
};

export const isWithinUsdLimit = (params) => {
  const { amount, currency } = params || {};

  const rate = USD_EXCHANGE_RATES[currency];
  if (!rate || !amount || !currency) {
    return false;
  };

  const amountInUsd = amount * rate;

  // limit is USD5000
  return amountInUsd <= 500000;
};

export const formatToUTCString = (date) => {
  const options = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC',
  };

  const formatter = new Intl.DateTimeFormat('en-GB', options);

  const parts = formatter.formatToParts(date);
  const hash = Object.fromEntries(parts.map(p => [p.type, p.value]));

  return `${hash.day} ${hash.month} ${hash.year} ${hash.hour}:${hash.minute} ${hash.dayPeriod}`;
};

export const landingPageMetaProps = {
  "title": "GemstoneX - B2B Gemstone Marketplace Australia",
  "description": "Connect wholesale gemstone buyers and sellers across Australia and worldwide. Seamless online transactions and trusted network.",
  "schema": {
    "@context": "http://schema.org",
    "@type": "WebPage",
    "description": "Connect wholesale gemstone buyers and sellers across Australia and worldwide. Seamless online transactions and trusted network.",
    "name": "GemstoneX - B2B Gemstone Marketplace Australia",
    "image": [
      "https://sharetribe-assets.imgix.net/695c5f29-8137-4509-a6be-f6e37ca390d7/raw/f1/87969fa9f09d3f5b4813ea7a26f728eb60d5b1?auto=format&fit=clip&h=1200&w=1200&s=8a87f25701d5b595e1bf5f882c48e505"
    ]
  },
  "socialSharing": {
    "title": "GemstoneX - Your B2B Gemstone Marketplace",
    "description": "Join GemstoneX today and access a global network of gemstone wholesale buyers and sellers. Simplify your transactions and grow your business.",
    "images1200": [{
      "url": "https://sharetribe-assets.imgix.net/695c5f29-8137-4509-a6be-f6e37ca390d7/raw/f1/87969fa9f09d3f5b4813ea7a26f728eb60d5b1?auto=format&fit=clip&h=1200&w=1200&s=8a87f25701d5b595e1bf5f882c48e505",
      "width": 1200,
      "height": 562
    }],
    "images600": [{
      "url": "https://sharetribe-assets.imgix.net/695c5f29-8137-4509-a6be-f6e37ca390d7/raw/f1/87969fa9f09d3f5b4813ea7a26f728eb60d5b1?auto=format&fit=clip&h=600&w=600&s=d5bf3d29b9e8ee0c4aa0d68b049c4b6f",
      "width": 600,
      "height": 281
    }],
  },
};

export const dummyListingObject = {
  "attributes": {
    "title": "Vivid Green Muzo Emerald", // taken
    "publicData": {
      "caratWeight": 3.45, // taken
      "clarityGrade": "eyeClean",
      "colourDescription": "Pure Green/Light/S1",
      "colourHue": "pureGreen", // taken
      "colourSaturation": "s1",
      "colourTone": "light",
      "countryOfOrigin": "Colombia",
      "currency": "AUD",
      "cuttingQualification": "--",
      "depth": 2,
      "depthPercentage": 1,
      "formation": "--",
      "gemType": "emerald", // taken
      "inclusionsDescription": "nothing",
      "incoterms": "--",
      "internalColourTier": "--",
      "internalNotes": "--",
      "labReportAvailable": "no",
      "labName": "gsl", // taken
      "leadTime": "4",
      "length": 2,
      "lengthWidthRatio": 1,
      "listingType": "sell-supplier",
      "listingUpdated": "16 January 2026 04:56 am",
      "lotType": "singleStone",
      "originRegion": "Muzo",
      "originSource": "--",
      "pricePerCarat": 500000,
      "priceType": "fixed",
      "productType": "matchedSet",
      "reportDate": "--",
      "stockLocation": "London",
      "stoneCut": "step", // taken
      "stoneShape": "oval",
      "transactionProcessAlias": "default-purchase/release-1",
      "transparency": "transparent",
      "treatmentDisclosure": "disclosure",
      "treatmentLevel": "noOil",
      "treatmentType": "oil", // taken
      "unitType": "item",
      "width": 2
    },
    "deleted": false,
    "geolocation": null,
    "state": "published",
    "price": new Money(1000000, "AUD"),
  },
  "id": {
    "_sdkType": "UUID",
    "uuid": "EMR-MZ-2025-001"
  },
  "type": "listing",
  "author": {
    "attributes": {
      "profile": {
        "abbreviatedName": "NI",
        "displayName": "NI",
        "publicData": {},
        "metadata": {}
      }
    },
    "id": {
      "_sdkType": "UUID",
      "uuid": "695c7e0c-25ba-40c2-96b5-935751c081fe"
    },
    "type": "user"
  },
};